import React from 'react';
import { Separator } from './ui/Separator';
export function Footer() {
  const currentYear = new Date().getFullYear();
  const scrollTo = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) element.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  return <footer className="w-full bg-primary text-primary-foreground py-16 px-6" data-id="element-6">
      <div className="max-w-7xl mx-auto" data-id="element-7">
        <div className="flex flex-col items-center mb-12" data-id="element-8">
          <img src="https://cdn.magicpatterns.com/uploads/uCxAG9G8XRJkgLABzP5wZi/3dots-logo-white-sanitized.svg" alt="3 DOTS Travel" className="h-10 w-auto mb-6" data-id="element-9" />
          <p className="text-xs uppercase tracking-[0.3em] text-primary-foreground/60 mb-8" data-id="element-10">
            Bespoke Journeys · Thoughtfully Designed · Deeply Experienced
          </p>
          <nav className="flex flex-wrap justify-center gap-6" data-id="element-11">
            {[{
            label: 'About',
            href: '#about'
          }, {
            label: 'Philosophy',
            href: '#philosophy'
          }, {
            label: 'Destinations',
            href: '#destinations'
          }, {
            label: 'Beyond',
            href: '#beyond'
          }, {
            label: 'How It Works',
            href: '#how-it-works'
          }, {
            label: 'Contact',
            href: '#contact'
          }].map(item => <a key={item.href} href={item.href} onClick={e => scrollTo(e, item.href)} className="text-xs uppercase tracking-[0.15em] text-primary-foreground/50 hover:text-primary-foreground transition-colors" data-id="element-12">
                {item.label}
              </a>)}
          </nav>
        </div>

        <Separator className="bg-primary-foreground/10 mb-8" data-id="element-13" />

        <div className="flex flex-col md:flex-row justify-between items-center text-xs text-primary-foreground/40 tracking-wide" data-id="element-14">
          <p data-id="element-15">© {currentYear} 3 DOTS Travel. All rights reserved.</p>
          <p className="mt-4 md:mt-0" data-id="element-16">Private Travel Design Studio</p>
        </div>
      </div>
    </footer>;
}